import React from 'react';
import { Box, Image, Text } from '@user-portal/wikr-components';

import OutlinedButton from 'components/OutlinedButton';
import Modal from 'components/Modal';

import * as S from './styled';

import sandClock from 'assets/img/webp/sand_clock.webp';

import { IWaitingModal } from './types';

const WaitingModal = ({
    onDiscard,
    onClose,
    withCloseButton,
    captions,
    trackLoad,
    dataLocatorContainer,
}: IWaitingModal) => (
    <Modal
        isOpen
        onClose={onClose}
        trackLoad={trackLoad}
        withCloseButton={withCloseButton}
        dataLocatorContainer={dataLocatorContainer}
    >
        <Box $paddingTop={8} $paddingBottom={8}>
            <Image maxWidth={48} center alt="sand clock" src={sandClock} mb={12} />
            <Text type="h5" center mb={24}>
                {captions.title}
            </Text>
            {captions.subtitle && (
                <Text center mb={24}>
                    {captions.subtitle}
                </Text>
            )}
            <Box>
                <S.Spinner />
            </Box>
            {onDiscard && captions.discardButton && (
                <OutlinedButton dataLocator="stopCancelBtn" onClick={onDiscard}>
                    {captions.discardButton}
                </OutlinedButton>
            )}
        </Box>
    </Modal>
);

export default WaitingModal;
